import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import { AccordionAnimation } from "@components/Accordion/AccordionAnimation";
import { Icon } from "@components/Icon";
import { styledWithInvalidProps } from "@components/Styled/StyledWithInvalidProps";
import React from "react";
import tw from "twin.macro";
import {
  FilterSectionOutputProps,
  withFilterSection,
} from "./withFilterSection";

const FilterSectionWrapper = styledWithInvalidProps("div")(
  ({ show }: { show: boolean }) => [
    tw`w-full overflow-hidden`,
    show ? tw`border-b` : tw``,
  ],
);

const FilterTitleWrapper = tw.div`
  flex w-full border-b items-center justify-start transition-presentation hover:text-secondary
`;

const FilterTitle = withFocusRing(tw.button`
  grow text-left pt-maxi pb-maxi
`);

const FilterToggle = withFocusRing(
  styledWithInvalidProps(Icon)(({ show }: { show: boolean }) => [
    tw`mx-mini mt-pico transform rotate-90 transform-gpu`,
    show ? tw`-rotate-90` : null,
  ]),
);

const TitleCount = tw.span`ml-mini text-hint text-primary`;

export const FilterSection = withFilterSection(
  ({
    children,
    title,
    show,
    setShow,
    selectedCount,
  }: FilterSectionOutputProps) => {
    return (
      <FilterSectionWrapper show={show}>
        <FilterTitleWrapper onClick={() => setShow((show) => !show)}>
          <FilterTitle>
            <span>{title}</span>
            <TitleCount data-testid="selected-count">
              {selectedCount}
            </TitleCount>
          </FilterTitle>
          <FilterToggle show={show} name="chevron" size="xxxs" />
        </FilterTitleWrapper>
        <AccordionAnimation active={show}>{children}</AccordionAnimation>
      </FilterSectionWrapper>
    );
  },
);
